import React from 'react'
import { css } from 'glamor'
import { propMerge } from 'glamor/react'
import { mediaQueries } from '../../constants/mediaQueries'

const styles = css({
	fontSize: "16px",
	fontWeight: "600",
	marginTop: "52px",
	[mediaQueries.isMobile]: {
		fontSize: '16px',
	},
})

const H5 = ({ children, ...otherProps }) => {
	return <h5 {...propMerge(styles, otherProps)}>{children}</h5>
}

export default H5
